import React from "react";
import { TabContainer, Table, Row, Col, ListGroup, ListGroupItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Api } from "../../Helpers/axios/axios";
import { TablePagination } from "./TablePagination";
import { rTableInterface } from "./rTableInterface";
import { PUBLIC_URL } from "../../Helpers/config/config";
import { Popup } from "../PopUp/Popup";
import { ExportToCsv } from "export-to-csv";
import "./RTable.css";
import "../CardGrid/CardGrid.css";
import { LoadingSpinner } from "../Spinner/LoadingSpinner";
import { QueryGenerator } from "./QueryGenerator";

export interface state {
  error: string | null;
  isLoaded: boolean;
  items: any[];
  count: number;
  trigger: boolean;
  data: any;
  isMobile: boolean;
  searchVal: string;
  searchCol: string;
}

export class RTable extends React.Component<rTableInterface> {
  state: state = {
    error: null,
    isLoaded: false,
    items: [],
    count: 0,
    trigger: false,
    data: {},
    isMobile: window.innerWidth < 768,
    searchVal: "",
    searchCol: "",
  };

  private page = 1;
  private limit = 10;
  private where: any = {};
  private searchTimeout: any = null;

  fetch = async (Update = false) => {
    let finalWhere = { ...this.where };
    if (this.state.searchCol && this.state.searchVal.trim() !== "") {
      finalWhere[this.state.searchCol] = this.state.searchVal.trim();
    } else if (this.state.searchCol) {
      delete finalWhere[this.state.searchCol];
    }

    if (Update && this.props.api) {
      Api.post(this.props.api, {
        where: finalWhere,
        page: this.page,
        limit: this.limit,
      })
        .then((result: any) => {
          this.setState({
            isLoaded: true,
            items: result.data || [],
            count: result.count || 0,
          });
        })
        .catch((err) => {
          alert(err?.message || err);
        });
    }

    if (this.props.api && !Update) {
      return Api.post(this.props.api, { 
        where: finalWhere,
        page: this.page, 
        limit: this.limit 
      });
    }
  };

  SrNo(index: number): number {
    return (this.page - 1) * this.limit + index;
  }

  handleResize = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  };

  componentDidMount(): void {
    window.addEventListener("resize", this.handleResize);
    
    let defaultSearchCol = "";
    if (this.props.tableStructure) {
      const searchableCols = this.props.tableStructure.filter((col: any) => {
        const nameLower = col.name?.toLowerCase() || "";
        if (nameLower === "action" || nameLower === "id" || nameLower === "sr no" || nameLower === "sr. no." || nameLower === "sr.no" || nameLower === "no") {
          return false;
        }
        return col.key || nameLower === "name" || nameLower === "title" || nameLower === "email" || nameLower === "phone";
      });
      if (searchableCols.length > 0) {
        defaultSearchCol = searchableCols[0].key || searchableCols[0].name.toLowerCase();
      }
    }

    this.setState({ searchCol: defaultSearchCol }, () => {
      if (this.props.api) {
        this.fetch()
          .then((result: any) => {
            this.setState({
              isLoaded: true,
              items: result.data || [],
              count: result.count || 0,
            });
          })
          .catch((err) => {
            alert(err?.message || err);
          });
      }
    });
  }

  componentWillUnmount(): void {
    window.removeEventListener("resize", this.handleResize);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  renderCards = (data: any) => {
    return data.map((d: any, index: any) => {
      return (
        <Col key={index}>
          <div className="custom-card mb-3">
            <div className="custom-card-header">
              <span className="entry-badge">#{this.SrNo(index + 1)}</span>
              <span>Entry Details</span>
            </div>
            <div className="custom-card-body">
              <ListGroup className="list-group-flush custom-list-group">
                {this.props.tableStructure
                  ? this.renderCardStructure(d, this.props.tableStructure)
                  : this.NrenderCardStructure(d)}
              </ListGroup>
            </div>
          </div>
        </Col>
      );
    });
  };

  renderCardStructure = (data: any, structure: any) => {
    return structure.map((key: any, index: number) => {
      if (key.name === "id") return null;

      let val;
      if (key.render) {
        if (key.name === "Action") {
          val = (
            <div className="action-cell-container">
              {key.render(data, this.onDelete)}
            </div>
          );
        } else {
          val = key.render(data, this.SrNo(index));
        }
      } else {
        val = data[key.key];
      }
      return (
        <ListGroupItem key={index}>
          <span className="item-label">{key.name}</span>
          <span className="item-value">{val}</span>
        </ListGroupItem>
      );
    });
  };

  NrenderCardStructure = (data: any) => {
    return Object.keys(data).map((key: any, index: number) => {
      if (key === "id") return null;
      return (
        <ListGroupItem key={index}>
          <span className="item-label">{key}</span>
          <span className="item-value">{data[key]}</span>
        </ListGroupItem>
      );
    });
  };

  renderHeading = (struct: any) => {
    return struct.map((head: any) => {
      return <th>{head.name}</th>;
    });
  };

  onDelete = (id: number) => {
    Api.delete(`${this.props.deleteUrl}/${id}`)
      .then(() => {
        this.fetch(true);
      })
      .catch((error) => {
        alert(error?.message || error);
      });
  };

  onClick = (event: any) => {
    if (event.target.text && event.target.text != "") {
      this.page = parseInt(event.target.text);
      this.fetch(true);
    }
  };

  onClickNext = (event: any) => {
    this.page = this.page + 1;
    this.fetch(true);
  };

  onClickPrevious = (event: any) => {
    this.page = this.page - 1;
    this.fetch(true);
  };

  onSelectClick = (event: any) => {
    this.limit = event.target.value;
    this.page = 1;
    this.fetch(true);
  };

  renderBody = (data: any) => {
    return data.map((d: any, index: any) => {
      return <tr>{this.renderData(d, index + 1)}</tr>;
    });
  };

  renderData = (data: any, index: any) =>
    this.props.tableStructure?.map((format: any) => {
      if (format.render && format.name === "Action") {
        return (
          <td>
            <div className="action-cell-container">
              {format.render(data, this.onDelete)}
            </div>
          </td>
        );
      } else if (format.render) {
        return <td>{format.render(data, this.SrNo(index))}</td>;
      }
      return <td>{data[format.key]}</td>;
    });

  NrenderHeading = (data: any, action: boolean = true) => {
    let a = Object.keys(data[0]).map((key: any) => {
      return <th>{key}</th>;
    });
    if (this.props.ActionEditLink || this.props.ActionDeleteLink) {
      let b = <th>Action</th>;
      return [...a, b];
    }
    return a;
  };

  NrenderBody = (data: any) => {
    let a = data.map((d: any) => {
      return <tr>{this.NrenderData(d)}</tr>;
    });
    return a;
  };

  NrenderData = (data: any) => {
    let a = Object.keys(data).map((key: any) => {
      return <td>{data[key]}</td>;
    });
    if (this.props.ActionEditLink || this.props.ActionEditLink) {
      let b = (
        <td>
          <div className="action-cell-container">
            <Link to={`/UserForm/${data.id}`}>
              <img width="16px" src={PUBLIC_URL + "/images/edit.svg"} alt="edit" />
            </Link>
            <Link
              to="#"
              onClick={() => {
                this.onDelete(data.id);
              }}
            >
              <img width="16px" src={PUBLIC_URL + "/images/delete.svg"} alt="delete" />
            </Link>
          </div>
        </td>
      );
      return [...a, b];
    }
    return a;
  };

  ErenderHeading = (data: any, action: boolean = true) => {
    let a = Object.keys(data[0]).map((key: any) => {
      return key;
    });
    return a;
  };

  ErenderBody = (data: any) => {
    let a = data.map((d: any) => {
      return this.ErenderData(d);
    });
    return a;
  };

  ErenderData = (data: any) => {
    let a = Object.keys(data).map((key: any) => {
      if (typeof data[key] === "object") {
        return JSON.stringify(data[key]);
      }
      return data[key];
    });
    return a;
  };

  extractTextFromChildren = (children: any): string => {
    if (!children) return "";
    if (typeof children === "string" || typeof children === "number") {
      return String(children);
    }
    if (Array.isArray(children)) {
      return children.map((c) => this.extractTextFromChildren(c)).join(" ").trim();
    }
    if (typeof children === "object") {
      if (children.props?.children) {
        return this.extractTextFromChildren(children.props.children);
      }
      if (children.props?.alt) {
        return `[${children.props.alt}]`;
      }
    }
    return "";
  };

  extractTextFromRendered = (rendered: any, item: any, fallbackKey?: string): string => {
    if (rendered === null || rendered === undefined) {
      return "";
    }
    if (typeof rendered === "string" || typeof rendered === "number" || typeof rendered === "boolean") {
      return String(rendered);
    }

    if (typeof rendered === "object") {
      // If it's an anchor element (like the Resume link)
      if (rendered.type === "a" && rendered.props?.href) {
        if (rendered.props.href.startsWith("http") || rendered.props.href.includes("download")) {
          return rendered.props.href;
        }
      }
      
      // If it's a Link component from react-router-dom
      if (rendered.props?.to && typeof rendered.props.to === "string") {
        return rendered.props.to;
      }

      if (rendered.props?.children) {
        return this.extractTextFromChildren(rendered.props.children);
      }
    }

    if (fallbackKey && item[fallbackKey] !== undefined) {
      return String(item[fallbackKey]);
    }

    return "";
  };

  export = () => {
    let data = this.props.data || this.state.items;
    let columns: string[] = [];
    let exportData: any[] = [];

    if (this.props.tableStructure) {
      // Filter out Action columns as they make no sense in a CSV export
      const exportCols = this.props.tableStructure.filter(
        (col: any) => col.name?.toLowerCase() !== "action"
      );

      columns = exportCols.map((col: any) => col.name);
      exportData = data.map((item: any, index: number) => {
        const rowObj: any = {};
        exportCols.forEach((col: any) => {
          let val = "";
          if (col.render) {
            const srNo = this.SrNo(index + 1);
            const rendered = col.render(item, srNo);
            val = this.extractTextFromRendered(rendered, item, col.key);
          } else if (col.key) {
            val = item[col.key];
          }
          rowObj[col.name] = val !== null && val !== undefined ? String(val) : "";
        });
        return rowObj;
      });
    } else {
      columns = this.props?.ExportStructure
        ? this.renderHeading(this.props.ExportStructure)
        : this.ErenderHeading(data, false);

      exportData = data.map((item: any) => {
        const rowObj: any = {};
        columns.forEach((key: string) => {
          rowObj[key] = item[key] !== null && item[key] !== undefined ? String(item[key]) : "";
        });
        return rowObj;
      });
    }

    var today = new Date();
    var date =
      today.getFullYear() +
      "_" +
      (today.getMonth() + 1) +
      "_" +
      today.getDate();
    var time =
      today.getHours() + "_" + today.getMinutes() + "_" + today.getSeconds();
    var dateTime = date + "_" + time;
    let filename = this.props.xFileName ? `${this.props.xFileName}_${dateTime}.csv` : `export_${dateTime}.csv`;

    const options = {
      fieldSeparator: ",",
      quoteStrings: '"',
      decimalSeparator: ".",
      showLabels: true,
      showTitle: false,
      filename: filename,
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: false,
      headers: columns,
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(exportData);
    return;
  };

  totalPages(): number {
    if (this.limit == -1) {
      return 1;
    }
    return Math.ceil(this.state.count / this.limit);
  }

  triggerEvent = (action: boolean) => {
    this.setState({ trigger: action });
  };

  queryChange = (key: string, value: any) => {
    let d = { ...this.state.data };
    d[key] = value;
    let state = this.state;
    state.data = d;
    this.setState(state);
    if (key != "selector") {
      this.where[key] = value;
      this.page = 1;
      this.fetch(true);
    }
  };

  handleSearchChange = (val: string) => {
    this.setState({ searchVal: val });
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.page = 1;
      this.fetch(true);
    }, 500);
  };

  clearSearch = () => {
    this.setState({ searchVal: "" }, () => {
      this.page = 1;
      this.fetch(true);
    });
  };

  render() {
    const searchableCols = this.props.tableStructure
      ? this.props.tableStructure.filter((col: any) => {
          const nameLower = col.name?.toLowerCase() || "";
          if (nameLower === "action" || nameLower === "id" || nameLower === "sr no" || nameLower === "sr. no." || nameLower === "sr.no" || nameLower === "no") {
            return false;
          }
          return col.key || nameLower === "name" || nameLower === "title" || nameLower === "email" || nameLower === "phone";
        }).map((col: any) => {
          return {
            key: col.key || col.name.toLowerCase(),
            name: col.name
          };
        })
      : [];

    if (this.state.items.length !== 0) {
      let params = this.props;
      let trig = this.state.trigger;
      let data = this.props.data || this.state.items;
      let TotalRecord = this.state.count;
      return (
        <TabContainer key={"TabContainer"}>
          <div className="Buttons">
            <div className="bg-success p-2 text-dark bg-opacity-25 record">
              Total Records: {this.state.count}
            </div>

            {searchableCols.length > 0 && (
              <div className="search-container-inline">
                <select
                  className="form-select search-select"
                  value={this.state.searchCol}
                  onChange={(e) => {
                    this.setState({ searchCol: e.target.value }, () => {
                      if (this.state.searchVal.trim() !== "") {
                        this.page = 1;
                        this.fetch(true);
                      }
                    });
                  }}
                >
                  {searchableCols.map((col: any) => (
                    <option key={col.key} value={col.key}>
                      Search by {col.name}
                    </option>
                  ))}
                </select>
                <div className="search-divider"></div>
                <input
                  type="text"
                  className="form-control search-input"
                  placeholder="Search..."
                  value={this.state.searchVal}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                />
                {this.state.searchVal && (
                  <button className="search-clear-btn" onClick={this.clearSearch} title="Clear search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
              </div>
            )}

            {this.props.Addlink && (
              <Link
                to={this.props.Addlink}
                type="button"
                className="btn btn-outline-primary Export"
                onClick={() => {
                  this.triggerEvent(true);
                }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                  focusable="false"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                </svg>
                Add New
              </Link>
            )}

            <button
              type="button"
              className="btn btn-outline-success Export"
              onClick={() => {
                this.export();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="#007745"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21" />
                <path d="M16 16l-4-4-4 4" />
              </svg>
              Export
            </button>

            {this.props.searchReg && (
              <button
                type="button"
                className="btn btn-outline-secondary searchButton"
                onClick={() => {
                  this.triggerEvent(true);
                }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                  focusable="false"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z">
                    {" "}
                  </path>
                </svg>
                Search
              </button>
            )}
          </div>
          <Popup
            trigger={trig}
            setSearch={this.triggerEvent}
            heading={<h4>Search</h4>}
          >
            <QueryGenerator
              data={this.state.data}
              qChange={this.queryChange}
              queryRef={this.props.searchReg}
            />
          </Popup>
          {this.state.isMobile ? (
            <Row xs={1} className="g-4 mb-4">
              {this.renderCards(data)}
            </Row>
          ) : (
            <Table key={"Table"} responsive striped bordered hover>
              <thead>
                <tr>
                  {params?.tableStructure
                    ? this.renderHeading(params.tableStructure)
                    : this.NrenderHeading(data)}
                </tr>
              </thead>
              <tbody>
                {params?.tableStructure
                  ? this.renderBody(data)
                  : this.NrenderBody(data)}
              </tbody>
            </Table>
          )}
          <TablePagination
            key={"TablePagination"}
            onSelectClick={this.onSelectClick}
            onClick={this.onClick}
            totalPages={this.totalPages()}
            page={this.page}
            TotalRecord={TotalRecord}
            onClickNext={this.onClickNext}
            onClickPrevious={this.onClickPrevious}
          />
        </TabContainer>
      );
    } else {
      let trig = this.state.trigger;
      return this.state?.isLoaded === false ? (
        <LoadingSpinner />
      ) : (
        <TabContainer key={"TabContainer"}>
          <div className="Buttons">
            <div className="bg-success p-2 text-dark bg-opacity-25 record">
              Total Records: {this.state.count}
            </div>

            {searchableCols.length > 0 && (
              <div className="search-container-inline">
                <select
                  className="form-select search-select"
                  value={this.state.searchCol}
                  onChange={(e) => {
                    this.setState({ searchCol: e.target.value }, () => {
                      if (this.state.searchVal.trim() !== "") {
                        this.page = 1;
                        this.fetch(true);
                      }
                    });
                  }}
                >
                  {searchableCols.map((col: any) => (
                    <option key={col.key} value={col.key}>
                      Search by {col.name}
                    </option>
                  ))}
                </select>
                <div className="search-divider"></div>
                <input
                  type="text"
                  className="form-control search-input"
                  placeholder="Search..."
                  value={this.state.searchVal}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                />
                {this.state.searchVal && (
                  <button className="search-clear-btn" onClick={this.clearSearch} title="Clear search">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
              </div>
            )}

            {this.props.Addlink && (
              <Link
                to={this.props.Addlink}
                type="button"
                className="btn btn-outline-primary Export"
                onClick={() => {
                  this.triggerEvent(true);
                }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                  focusable="false"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path>
                </svg>
                Add New
              </Link>
            )}

            <button
              type="button"
              className="btn btn-outline-success Export"
              onClick={() => {
                this.export();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="#007745"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21.2 15c.7-1.2 1-2.5.7-3.9-.6-2-2.4-3.5-4.4-3.5h-1.2c-.7-3-3.2-5.2-6.2-5.6-3-.3-5.9 1.3-7.3 4-1.2 2.5-1 6.5.5 8.8m8.7-1.6V21" />
                <path d="M16 16l-4-4-4 4" />
              </svg>
              Export
            </button>

            {this.props.searchReg && (
              <button
                type="button"
                className="btn btn-outline-secondary searchButton"
                onClick={() => {
                  this.triggerEvent(true);
                }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  aria-hidden="true"
                  focusable="false"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z">
                    {" "}
                  </path>
                </svg>
                Search
              </button>
            )}
          </div>

          <Popup
            trigger={trig}
            setSearch={this.triggerEvent}
            heading={<h4>Search</h4>}
          >
            <QueryGenerator
              data={this.state.data}
              qChange={this.queryChange}
              queryRef={this.props.searchReg}
            />
          </Popup>

          <Table key={"Table"} striped bordered hover>
            <thead>
              <tr>
                <th align="right">nodata</th>
              </tr>
            </thead>
          </Table>
        </TabContainer>
      );
    }
  }
}
